import { request } from '../helpers/request'
import LoadingComponent from './common/LoadingComponent'
import React from 'react'
import ModalComponent from './common/ModalComponent'
import Immutable from 'immutable'
import $ from 'jquery'
import {Button} from 'react-bootstrap'
import { t } from '../helpers/translate'
let config = require('config');

class ResourceCentre extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalTitle: null,
      modalBody: null,
      data: Immutable.Map({}),
      display: 'resource',
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setState({ display: 'resource' });
    }
  }

  handleResponse(responseData, statusCode) {
    if (statusCode == 200) {
      let articleData = Immutable.fromJS(responseData);
      this.setState({
       data: articleData.toJS(),
       loading: false
      })
    } else {
      this.setState({loading: false});
      this.showModal(t('Error'), t('Unable to get application data'));
    }
  }

  showModal(title, body) {
    this.setState({
      showModal: true,
      modalBody: body,
      modalTitle: title
    })
  }

  handleModalClose() {
    this.setState({
      showModal: false
    })
  }

  loadData(article) {
    this.setState({loading : true})
    const urlSuffix = config.default.resource_centre.pageInfo[article].url_suffix;
    const payLoad = config.default.resource_centre.pageInfo[article].payload;

    request(`${config.default.api}${urlSuffix}`, 'POST', payLoad, this.handleResponse.bind(this));
  }

  readArticle(link) {
    window.open(link)
  }

  scrollToTheTop() {
    $('html, body').animate({ scrollTop: 0 }, 'fast');
  }

  toggleSelection(resource) {
    if ((resource.extLink != undefined) && (resource.extLink.length > 0)){
      return window.open(resource.extLink);
    }
    else if(resource.fetchFromWP){
      this.loadData(resource.type);
    }
    this.setState({ display: resource.type });
    this.scrollToTheTop();
  }

  renderResource(item) {
    let itemContent = (
      <div className="col-md-6">
        <div className="resource-content">
          <div className="row">
            <div className="col-md-3 text-center">
              <img className="img-resource" src={item.logo} />
            </div>
            <div className="col-md-9 sub-resource text-container">
              <h2 className="resources-tile-title">{item.title}</h2>
              <p className="resources-tile-subtext">{item.shortIntro}</p>
              <button
                className="btn button-primary"
                onClick={this.toggleSelection.bind(this, item)}
              >{`${t('Read More')}`}</button>
            </div>
          </div>
        </div>
      </div>
    );
    return itemContent;
  }

  getImage(img) {
    if(img == undefined)
    {
      return null
    }
    else{
      return (<img className="img-blog blog-thumbnail" src={img.attachment_meta.sizes.thumbnail.url} />)
    }
  }

  formatDate(date) {
    return date.split("T")[0];
  }

  titleDecode(title) {
    return $("<textarea/>").html(title).text();
  }

  renderArticle(article) {
    let articleContent = (
      <div className="col-md-12">
        <div className="resource-content">
          <div className="row">
              <div className="col-md-4 text-center">
                {this.getImage(article.featured_image)}
              </div>
              <div className="col-md-8 sub-article text-container">
                <h2>{this.titleDecode(article.title)}</h2>
                <p>{this.formatDate(article.date)} | {article.author.name}</p>
                <button
                  className="btn button-secondary"
                  onClick={this.readArticle.bind(this, article.link)}>{`${t('Read More')}`}</button>
              </div>
          </div>
        </div>
      </div>
    );
    return articleContent;
  }

  renderGovernment(article) {
    let articleContent = (
      <div className="col-md-12">
        <div className="resource-content">
          <div className="row">
              <div className="col-md-4 text-center">
                <img className="img-blog blog-thumbnail" src={article.logo} />
              </div>
              <div className="col-md-8 sub-article text-container">
                <h2>{article.title}</h2>
                <p>{article.shortIntro}</p>
                <button
                  className="btn button-secondary"
                  onClick={this.readArticle.bind(this, article.link)}>{`${t('Read More')}`}</button>
              </div>
          </div>
        </div>
      </div>
    );
    return articleContent;
  }

  renderArticles() {
      if (!this.state.loading) {
        let articleList = [];
        let renderMethod = null;
        const configData = config.default.resource_centre;

        if(configData.resources[this.state.display] == undefined){
          articleList = Object.values(configData.resources);
          renderMethod  = (blog) => this.renderResource(blog);
        }
        else{
          const fetchFromWP = configData.resources[this.state.display].fetchFromWP;
          articleList = fetchFromWP ? this.state.data : configData.government;
          renderMethod = fetchFromWP ? ((blog) => this.renderArticle(blog)) : ((blog) => this.renderGovernment(blog));
        }
        return (
            <div>
              {this.renderPageTitles()}
              {articleList.map((blog, i) => {
                return <div key={i}>{renderMethod(blog)}</div>;
              })}
            </div>
        )
      }
    }

  renderPageTitles() {
    const pageName = this.state.display;
    return (
      <div className="text-center col-md-12">
        <h2 className="page-title">{config.default.resource_centre.pageInfo[pageName].title}</h2>
        <h5 className="page-subtitle">{config.default.resource_centre.pageInfo[pageName].info}</h5>
      </div>
    );
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          {this.renderArticles()}
        </div>
        <LoadingComponent show={this.state.loading} text="Loading" />

        <ModalComponent 
          title={this.state.modalTitle} 
          body={this.state.modalBody}
          onClose={this.handleModalClose.bind(this)}
          show={this.state.showModal}
        />
      </div>
    );
  }
}

ResourceCentre.displayName = 'Resource Centre';
export default ResourceCentre;


// WEBPACK FOOTER //
// ./src/components/ResourceCentre.js